/**
 * "How RustDesk is secured at OptimumDesk" - pagina pentru CLIENTI, deschisa
 * din Settings -> Remote Connect.
 *
 * TEXTUL SE ALINIAZA CU RAPORTUL DE VERIFICARE (5 octombrie 2026, din sursa
 * rustdesk 1.4.9 si rustdesk-server 1.1.16, verdict PARTIAL). Se scrie numai
 * ce face sistemul azi. Doua lucruri NU se promit, dinadins:
 *  - "nimeni in afara de noi nu poate ajunge la statie": cheia serverului e
 *    publica, deci oricine stie serverul si un ID ajunge la fereastra de
 *    parola - protectia e parola / acceptul si, optional, lista de IP-uri;
 *  - blocarea setarilor fata de un administrator local: in RustDesk gratuit
 *    nu exista; agentul doar le reface si raporteaza.
 * Cine schimba ce face agentul sau serverul schimba si textul de aici.
 *
 * Cerintele de server (hbbr cu `-k _`, ALWAYS_USE_RELAY) NU sunt aici - sunt
 * pentru administrator, in nota de langa lista de servere.
 */
export function RustdeskSecurityNote() {
  return (
    <div className="rd-security" id="rustdesk-security-note">
      <p>
        OptimumDesk uses RustDesk for remote connections to your devices. This is how those connections are protected.
      </p>

      <h4>Your devices live on our server only</h4>
      <p>
        The OptimumDesk agent installs RustDesk and registers each device only on the OptimumDesk RustDesk servers set
        for your organization. The device's RustDesk ID is not registered on the public RustDesk servers. RustDesk uses
        one server at a time; if your organization has more than one, the agent moves a device to the next server only
        when the current one stops answering.
      </p>

      <h4>Settings are fixed by the agent</h4>
      <p>
        The agent writes RustDesk's settings itself and turns off direct connections by IP address, discovery on the
        local network, and changing settings remotely during a session. If these settings are changed on the device,
        the agent puts them back within a few seconds and reports the change, which appears in the device's event log.
      </p>

      <h4>Who can get in</h4>
      <p>
        One-time (temporary) passwords are turned off. A connection needs either the permanent password the agent
        generates for the device, which is stored encrypted in the OptimumDesk portal and shown only to technicians with
        the right permission, or — if your organization chose to ask first — the person at the device has to click{' '}
        <strong>Accept</strong>. Each time a technician opens the connection page, the portal records who it was and,
        when there is one, for which ticket.
      </p>

      <h4>Optional: allowed technician addresses</h4>
      <p>
        Your organization can give a list of IP addresses or ranges (for example our office or VPN exit addresses). When
        the list is set, RustDesk on your devices accepts connections only from those addresses, also through the relay.
      </p>

      <h4>What this does not do</h4>
      <ul>
        <li>
          The server's key is public by design, as in every RustDesk setup. Someone who knows our server address and a
          device ID can reach the password prompt; what stops them is the password or the person's acceptance, and the
          allowed address list if you set one.
        </li>
        <li>
          A local administrator on the device can still change or remove RustDesk. The agent restores the settings and
          reports the change, but the free RustDesk client cannot lock them against an administrator.
        </li>
      </ul>
    </div>
  )
}
